export default () => {
  const container = document.querySelector('.js-afmetingen-buitenmat');
  const select = document.getElementById('pa_afmetingen');
  const variationInput = document.querySelector('input.variation_id');
  if (!container && !select) return;

  const options = container.querySelectorAll('.js-afmetingen-buitenmat-item');

  [...options].forEach(option => {
    option.addEventListener('click', function() {
      // Remove active class from all options
      [...options].forEach(item => {
        item.classList.remove('active');
      })
      option.classList.add('active');

      // Set the value of the select
      let value = this.getAttribute('data-value');
      let id = this.getAttribute('data-id');
      let price = this.getAttribute('data-price');
      select.value = value;
      variationInput.value = id;

      // Trigger change event on the select element
      const event = new Event('change', {
        bubbles: true,
        cancelable: true
      });
      select.dispatchEvent(event);
    });
  })
}


// WEBPACK FOOTER //
// ./src/js/woocommerce/VariationBuitenmat.js